export default function getResource(label) {
    const resources = {
        inStore: 'En magasin',
        sameDayDelivery: 'Livraison le jour même',
        shipping: 'Livraison'
    };

    return resources[label];
}
